import LoadIndicator from 'devextreme-react/load-indicator'
import './loading.scss'

const Loading = (): JSX.Element => <LoadIndicator id="loadingIndicator" className="loading" visible={true} />

export default Loading
